import "./Contact.module.css";
import NavegaciNPrincipal from "@/reusable_sections/Header";
import EstamosATuDisposiciN from "./sections/EstamosATuDisposiciN";
import CanalesDeComunicaciN from "./sections/CanalesDeComunicaciN";
import FormularioDeConsultaDirecta from "./sections/FormularioDeConsultaDirecta";
import ClinicLocationMap from "./sections/ClinicLocationMap";
import DirectContactCTA from "./sections/DirectContactCTA";
import DoctoraliaBooking from "./sections/DoctoraliaBooking";
import Location from "./sections/Location";
import Journey from "./sections/Journey";
import Philosophy from "./sections/Philosophy";
import PieDePGinaInstitucional from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <NavegaciNPrincipal />
      <EstamosATuDisposiciN />
      <CanalesDeComunicaciN />
      <DirectContactCTA />
      <FormularioDeConsultaDirecta />
      <DoctoraliaBooking />
      <Philosophy />
      <Journey />
      <ClinicLocationMap />
      <Location />
      <PieDePGinaInstitucional />
    </div>;
}